import { Toast } from "antd-mobile";
import { Image, Upload } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import QRCode from "qrcodejs2";
import "./index.css";
import { imageConfig } from "../../../../config/config";
import copy from "copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { getText } from "../../../../utils/util";
import { get } from "@ant-design/plots/es/core/utils";
import { imgList } from "./img-list";

export default function Center({ userInfo }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  
  return (
    <div className="flex flex-col space-y-3">
      <div
        className="bg-neutral-800 rounded-xl p-4 flex items-center cursor-pointer hover:bg-neutral-700 transition-colors"
        onClick={() => {
          if (!(userInfo?.rzstatus == 2)) {
            navigate("/idcard");
          }
        }}
      >
        <div className="relative w-10 h-10 flex items-center justify-center">
          <img src="/securityCenter/mobile.png" alt="" className="w-6 h-6" />
          <img
            src={userInfo?.phone ? imgList["infocard-12"] : imgList["infocard-5"]}
            alt=""
            className="absolute -top-1 -right-1 w-4 h-4"
          />
        </div>
        <div className="ml-4 flex-1">
          <div className="text-white font-medium">{translate(getText("電話號碼"))}</div>
          <div className="text-gray-400 text-sm">
            {translate(getText(userInfo?.phone ? "綁定成功" : "請綁定手機號碼"))}
          </div>
          {userInfo?.phone && (
            <div className="text-gray-500 text-xs mt-0.5">{userInfo.phone}</div>
          )}
        </div>
      </div>

      <div className="bg-neutral-800 rounded-xl p-4 flex items-center cursor-pointer hover:bg-neutral-700 transition-colors">
        <div className="relative w-10 h-10 flex items-center justify-center">
          <img src="/securityCenter/email.png" alt="" className="w-6 h-6" />
          <img
            src={userInfo?.username ? imgList["infocard-12"] : imgList["infocard-5"]}
            alt=""
            className="absolute -top-1 -right-1 w-4 h-4"
          />
        </div>
        <div className="ml-4 flex-1">
          <div className="text-white font-medium">
            {translate(getText("電子郵件"))[0].toLocaleUpperCase() +
              translate(getText("電子郵件")).substring(1)}
          </div>
          <div className="text-gray-400 text-sm">
            {translate(getText(userInfo?.username ? "綁定成功" : "請綁定郵箱"))}
          </div>
          {userInfo?.username && (
            <div className="text-gray-500 text-xs mt-0.5">{userInfo.username}</div>
          )}
        </div>
      </div>

      <div
        className="bg-neutral-800 rounded-xl p-4 flex items-center cursor-pointer hover:bg-neutral-700 transition-colors"
        onClick={() => {
          if (!(userInfo?.rzstatus == 2)) {
            navigate("/idcard");
          }
        }}
      >
        <div className="relative w-10 h-10 flex items-center justify-center">
          <img src={imgList["infocard-18"]} alt="" className="w-6 h-6" />
          <img
            src={userInfo?.rzstatus == 2 ? imgList["infocard-12"] : imgList["infocard-5"]}
            alt=""
            className="absolute -top-1 -right-1 w-4 h-4"
          />
        </div>
        <div className="ml-4 flex-1">
          <div className="text-white font-medium">{translate(getText("身份驗證"))}</div>
          <div className="text-gray-400 text-sm">
            {translate(
              getText(
                userInfo?.rzstatus == 2 ? "綁定成功" : "完成實名認證,方便資金管理"
              )
            )}
          </div>
        </div>
      </div>

      <div
        className="bg-neutral-800 rounded-xl p-4 flex items-center cursor-pointer hover:bg-neutral-700 transition-colors"
        onClick={() => {
          navigate("/changePassword");
        }}
      >
        <div className="w-10 h-10 flex items-center justify-center">
          <img src="/securityCenter/password.png" alt="" className="w-6 h-6" />
        </div>
        <div className="ml-4 flex-1">
          <div className="text-white font-medium">{translate(getText("更改密碼"))}</div>
          <div className="text-gray-400 text-sm">
            {translate(getText("定期修改密码利于账户安全"))}
          </div>
        </div>
      </div>
    </div>
  );
}
